<template>
  <div class="commerce-history-list">
    <p v-if="updating">
      <i class="fa fa-spinner fa-spin fa-lg has-text-primary" />
    </p>
    <div v-if="!transactions && !updating">{{ $t("commerce.no-ongoing") }}</div>
    <div v-else class="notification" style="padding:4px;">
      <div
        v-if="orderReady"
        class="panel-block"
        style="border-radius:4px; background-color:yellow; margin-bottom:8px; box-shadow:1px 1px 2px grey"
        @click="reminder"
      >
        <span class="tags has-addons single-line">
          <span class="tag is-white" style="padding: 0 3px">{{ $t("today") }}</span>
          <span class="tag is-grey">{{ $t("now") }}</span>
          <span class="tag is-dark" style="padding: 0 3px">#{{ o.ref }}</span>
          <span class="tag is-white">
            <i class="fa fa-user">&nbsp;</i>
            {{ o.phone_number }}
          </span>
          <span class="tag has-text-danger" style="background-color:yellow">
            <i class="fa fa-angle-double-left" />
            &nbsp;{{ $t("commerce.request-driver-now") }}&nbsp;
            <span
              class="pulse"
              style="padding:5px"
            >💣</span>
          </span>
          <!-- <span class="tag is-white pulse">💣</span> -->
        </span>
      </div>

      <div
        class="transaction"
        :style="backgroundStyle(t)"
        v-for="t in transactions"
        :key="t.id"
        @click="moreInfo(t)"
        v-ripple
      >
        <div class="columns is-mobile is-vcentered">
          <div class="column is-narrow ticket">
            <span v-if="numericRef(t)" class="is-size-3 has-text-weight-semibold">#{{ t.data.ref }}</span>
            <span v-else class="is-size-6 has-text-weight-semibold">{{ t.data.ref }}</span>
            <br />
            <i class="fa fa-shipping-fast is-size-4 has-text-primary" />
          </div>
          <div class="column middle">
            <div class="has-text-left">
              <p>
                <i class="fa fa-user pad" />
                {{ customerName(t) }}
                <!-- :class="stateClass(t)" -->
                <span
                  class="tag has-text-weight-semibold is-pulled-right"
                  :style="transactionStyle(t)"
                >{{ shortState(t) }}</span>
              </p>
              <p v-if="!isOld(t)">
                <i class="fa fa-clock pad" />
                {{ $t("ecommerce.ordered") }}
                <span
                  class="has-text-weight-medium"
                >{{ minutesAgo(t.created_at) }}</span>
              </p>
              <p>
                <i class="fa fa-coins pad" />
                <span>{{currency}}{{ orderValue(t) }}</span>&nbsp;
                <span
                  class="tag has-text-primary has-text-weight-semibold"
                >{{ $t("commerce.delivery") }}</span>
                <span v-if="isOld(t)" class="tag is-dark is-pulled-right">{{prettyDate(t)}}</span>
              </p>
            </div>
          </div>
          <div class="column is-1">
            <i class="fa fa-chevron-right fa-2x has-text-info" />
          </div>
        </div>
      </div>

      <!-- Removed old code -->
    </div>
    <br />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

export default {
  name: "CommerceHistoryList",
  components: {},
  data() {
    return {
      transactions: null,
      updating: false
    };
  },
  computed: {
    workflowID() {
      return this.$store.getters.getCommerceAgentRole.workflow_id; // this will exist
    },
    shortWorkflowID() {
      if (!this.workflowID) return "";
      return this.workflowID.substr(this.workflowID.length - 5);
    },
    o() {
      return this.$store.state.commerceOrder;
    },
    orderReady() {
      if (!this.o) return false;
      if (this.o.phone_number && this.o.ref && this.o.price) return true;
      return false;
    },
    currency() {
      return "฿";
    }
  },
  mounted() {
    this.getTransactionsInfo(); // get transactions first

    EventBus.$on("UPDATE_COMMERCE_HISTORY", () => {
      this.getTransactionsInfo();
    });

    setInterval(() => this.getTransactionsInfo(), 1000 * 60);
  },
  activated() {
    this.getTransactionsInfo();
  },
  methods: {
    customerName(t) {
      var name = t.customer.name || t.customer.phone_number;
      return this.shortenString(name, 20);
    },
    numericRef(t) {
      if (Number.isInteger(t.data.ref)) return true;
      if (!isNaN(t.data.ref)) return true;
      return false; //t.data.ref.length < 4
    },
    reminder() {
      var txt1 = this.$t("commerce.request-hint-1"); // This order has not been confirmed or sent to a driver yet !!
      var txt2 = this.$t("commerce.request-hint-2"); // After confirmation from the customer remember to click
      var truck = `<i class="fa fa-truck"></i>`;
      var request = this.$t("commerce.request-driver");
      this.$swal({
        type: "warning",
        html: `${txt1}<br><br>${txt2}<br><br><strong>〔${truck}&nbsp;${request}〕</strong>`,
        showCloseButton: true,
        showConfirmButton: false
      });
    },
    isOld(t) {
      return this.hoursAgo(t.created_at) > 24;
    },
    prettyDate(t) {
      var dt = new Date(t.created_at);
      return dt.toLocaleDateString();
    },
    orderValue(t) {
      return t.data.delivery.order_value;
    },
    prettyState(t) {
      if (t.state === "confirmed") return this.$t("ecommerce.being-prepared");
      if (t.state === "ready") return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      return t.state;
    },
    stateClass(t) {
      var tagClass = "is-dark";
      if (t.state === "confirmed") tagClass = "is-warning";
      if (t.state === "ready") tagClass = "is-orange";
      return tagClass;
    },
    shortState(t) {
      if (t.state === "cancelled_by_passenger") {
        return this.translateState("cancelled");
      }
      return this.translateState(t.state);
    },
    retry(t) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } }
        })
        .then(() => {
          this.thankYou("We are retrying the delivery request 🤞🏽");
          this.getTransactionsInfo();
        })
        .catch(err => console.error(err))
        .finally(() => loader.hide());
    },
    cancel(t) {
      this.$swal({
        title: this.$t("passenger.cancel-are-you-sure"),
        html: '<i class="fa fa-question fa-4x" />',
        showCancelButton: true,
        confirmButtonColor: "#f36",
        cancelButtonColor: "#00D1B2",
        cancelButtonText: this.$t("no"),
        confirmButtonText: this.$t("yes-cancel")
      }).then(val => {
        if (val.value) {
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchTransaction", {
              transactionID: t.id,
              data: {
                state: "cancelled_by_passenger",
                data: { cancel_reason: "shop-cancelled" }
              }
            })
            .then(() => {
              this.getTransactionsInfo();
              var youCancelled = this.$t("passenger.you-cancelled");
              var comeAgain = this.$t("passenger.come-again");
              this.$swal({
                html: `${youCancelled}<br>${comeAgain}`, //"Sorry you had to cancel...<br>Please come again!",
                showConfirmButton: false,
                timer: 2500
              });
            })
            .catch(err => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    shortTime(t) {
      var str = new Date(t.created_at).toLocaleTimeString("en-GB");
      return str.slice(0, 5);
    },
    date(t) {
      var dt = new Date(t.created_at);
      var dd = dt.getDate();
      var mm = dt.getMonth() + 1;
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return `${dd}/${mm}`;
    },
    backgroundStyle(t) {
      if (this.isToday(t)) return "background-color:lightyellow";
      return "background-color:white";
    },
    isToday(t) {
      var a = new Date().getDate();
      var b = new Date(t.created_at).getDate();
      if (a === b) return true;
      return false;
    },
    daysAgo(t) {
      // var ms = new Date().getTime() - new Date(t.created_at).getTime();
      // return ms / (1000 * 60 * 60 * 24);
      var days = new Date().getDate() - new Date(t.created_at).getDate();
      return days;
    },
    getTransactionsInfo() {
      this.updating = true;
      // var loader = this.loadingDots("pink");
      this.$store
        .dispatch("getDeliveryTransactionsByWorkflow", this.workflowID)
        .then(res => {
          console.log("getDeliveryTransactionsByWorkflow", res.data);
          this.transactions = res.data;
        })
        .catch(err => this.apiError(err))
        .finally(() => (this.updating = false)); //loader.hide());
    },
    transactionStyle(t) {
      var color = "pink";
      if (t.state === "alighted") color = "lightgreen";
      //   var liveStates = ["initiated", "confirmed", "driver_arrived", "enroute"];
      //   if (liveStates.includes(t.state)) color = "lightblue";
      if (t.state === "initiated") color = "yellow";
      if (t.state === "confirmed") color = "orange";
      if (t.state === "driver_arrived") color = "cyan";
      if (t.state === "enroute") color = "lightblue";
      return `background-color: ${color}`;
    },
    isOngoing(t) {
      if (t.is_ongoing && t.state !== "alighted") return true;
      return false;
    },
    isFailed(t) {
      // should we include cancelled_by_passenger?.. passenger shouldn't be able to cancel
      if (t.state === "timed_out" || t.state === "cancelled_by_driver")
        return true;
      return false;
    },
    // showState(t) {
    //   if (t.state === "alighted") return false;
    //   return true;
    // },
    referenceNumber(t) {
      if (!t.data.ref) return "?";
      return t.data.ref;
    },
    green(isOngoing) {
      if (isOngoing) return `background-color: lightgreen`;
      return `background-color: pink`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    moreInfo(t) {
      sounds("navigate1");
      var shortID = this.lastFive(t.id);
      var updated = new Date(t.updated_at);
      var timeDiff = Math.round((new Date() - updated) / (1000 * 60));
      var prettyTime = `${timeDiff} mins ago`;
      if (timeDiff > 60) {
        timeDiff = Math.round(timeDiff / 60);
        prettyTime = `${timeDiff} hours ago`;
      }
      var createdTime = new Date(t.created_at).toLocaleTimeString("en-GB");
      var ref = t.data.ref;
      var deliveryFee = t.data.fare.price;
      var orderAmount = t.data.delivery.order_value;
      var paymentMethod = this.translatePayment(t.data.delivery.payment_method);
      var driverName = "None";
      var driverPhone = "None";
      if (t.driver) {
        driverName = t.driver.name;
        driverPhone = t.driver.phone_number;
      }
      var phone = `<i class="fa fa-phone is-sm" style="color:green"></i>`;
      var state = this.translateState(t.state);
      var swalOpts = {
        html: `
        <div style='text-align:left; font-size:0.9em'>
        Order Reference <strong><i class='fa fa-receipt'></i>&nbsp;${ref}</strong><br>
        Order Amount <strong>${orderAmount}</strong><br>
        Delivery Fee <strong>${deliveryFee}</strong><br>
        Payment Method <strong>${paymentMethod}</strong><br>
        Customer <strong>${t.customer.name}</strong> ${phone}<a href='tel:${t.customer.phone_number}'>${t.customer.phone_number}</a><br>
        Driver <strong>${driverName}</strong> ${phone}<a href='tel:${driverPhone}'>${driverPhone}</a><br>
        State <strong>${state}</strong><br>
        Pickup <strong>${t.data.pickup_stop.name}</strong><br>
        Dropoff <strong>${t.data.dropoff_stop.name}</strong><br>
        Created <strong>${createdTime}</strong><br>
        Updated <strong>${prettyTime}</strong><br>
        ID <strong>${shortID}</strong></div>`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("commerce.retry-order"),
        cancelButtonText: this.$t("commerce.cancel-order"),
        confirmButtonColor: this.bulmaColor("success"),
        cancelButtonColor: this.bulmaColor("danger"),
        showCloseButton: true
      };
      var retryStates = ["timed_out", "cancelled_by_driver"];
      if (retryStates.includes(t.state)) {
        swalOpts.showCancelButton = false;
      } else if (t.state === "alighted") {
        swalOpts.showConfirmButton = false;
        swalOpts.showCancelButton = false;
      } else {
        swalOpts.showConfirmButton = false;
      }
      this.$swal(swalOpts).then(val => {
        if (val.value) this.retry(t);
        if (val.dismiss === "cancel") this.cancel(t);
        sounds("navigate2");
      });
    }
  }
};
</script>

<style scoped>
.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  padding: 4px 6px;
}
.panel-block::-webkit-scrollbar {
  display: none;
}
.tag {
  padding: 0 4px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.tags::-webkit-scrollbar {
  display: none;
}
.pulse {
  animation: glow 0.6s infinite alternate;
}
@keyframes glow {
  to {
    text-shadow: 0 0 5px red, 0 0 10px red, 0 0 15px red;
  }
}

/* new list style based on ecommerce */
.transaction {
  border-radius: 10px;
  border: 1px solid lightgrey;
  box-shadow: 0px 1px 1px lightgrey;
}
.columns {
  margin: 0 8px;
  padding: 4px;
}
.column.is-1 {
  padding: 0 0;
}
.column.middle {
  padding-right: 0;
}
.ticket {
  background-color: azure;
  border: 2px dotted grey;
  padding: 4px;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
}
.pad {
  margin-right: 10px;
}
</style>